export default "__VITE_ASSET__56485b60__"